import React from 'react';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      id: 1,
      title: "Total Asset\nProtection",
      description: "From satellites and UAVs to\nsubsurface sensors, Infinitus\ncaptures every layer of your\nasset. Nothing is left\nunmonitored.",
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30 5L45 12.5V30C45 42.5 30 55 30 55S15 42.5 15 30V12.5L30 5Z" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M22 30L27 35L38 24" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      id: 2,
      title: "Data To Decision\nIntelligence",
      description: "AI and Machine Learning drive early warning systems that transform raw readings into predictive alerts-helping you move from reactive to proactive monitoring.",
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 45C15 35 20 25 30 20C40 25 45 35 45 45" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M30 20C30 15 35 10 40 10C45 10 50 15 50 20" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M30 25C32 25 34 27 34 29C34 31 32 33 30 33C28 33 26 31 26 29C26 27 28 25 30 25Z" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M30 33V38" stroke="#FFD700" strokeWidth="2"/>
          <path d="M25 38H35" stroke="#FFD700" strokeWidth="2"/>
          <path d="M30 38L25 45L35 45L30 38Z" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M30 25L28 15M32 25L34 15" stroke="#FFD700" strokeWidth="1.5"/>
          <path d="M30 15L30 10" stroke="#FFD700" strokeWidth="1.5"/>
        </svg>
      )
    },
    {
      id: 3,
      title: "Smarter With \n Every Deployment",
      description: "Infinitus continuously learns. With every project, it uses AI and Machine Learning to refine accuracy to deliver deeper foresight and actionable insights that protect investments and safeguard communities.",
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="8" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M30 22L30 10M30 50L30 38M22 30L10 30M50 30L38 30M22 22L15 15M38 22L45 15M22 38L15 45M38 38L45 45" stroke="#FFD700" strokeWidth="2"/>
          <circle cx="30" cy="10" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="30" cy="50" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="10" cy="30" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="50" cy="30" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="15" cy="15" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="45" cy="15" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="15" cy="45" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="45" cy="45" r="3" stroke="#FFD700" strokeWidth="2" fill="none"/>
        </svg>
      )
    },
    {
      id: 4,
      title: "A Unified\nApproach",
      description: "One Platform. One Partner. Sensors, surveys, connectivity, data loggers, Progio integration, dashboards, and predictive AI all unified in one engineered bundle, One SLA. One partner. Zero finger-pointing.",
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="20" r="4" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="15" cy="30" r="4" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <circle cx="15" cy="40" r="4" stroke="#FFD700" strokeWidth="2" fill="none"/>
          <path d="M19 20L40 30M19 30L40 30M19 40L40 30" stroke="#FFD700" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="45" cy="30" r="6" stroke="#FFD700" strokeWidth="2" fill="none"/>
        </svg>
      )
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="features-wrapper">
        <h2 className="section-title">The Infinitus 2.0 Advantage</h2>
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
